import moment from 'moment';
import { pageConfig } from '@/common/service/page-config';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import _ from 'lodash';
import { mapGetters } from 'vuex';

const dateformat = 'MMM D, YYYY';


const span = {
  [BILLING_CYCLE.MONTHLY]: [1, 'month'],
  [BILLING_CYCLE.ANNUAL]: [1, 'year'],
  [BILLING_CYCLE.QUARTERLY]: [1, 'quarter'],
  [BILLING_CYCLE.TWO_YEARS]: [2, 'year'],
  [BILLING_CYCLE.THREE_YEARS]: [3, 'year'],
};
export default {
  computed: {
    ...mapGetters([
      'getSelectedPlans',
      'discountWithAmountMap',
      'currentEditPlan',
      'isCurrentEditDownSell',
      'getCurrentBasePlanInfo',
      'boughtPlans',
      'basicConfig',
      'mixBuyFlowContainsEditCase',
      'migratePlanState',
      'isZuoraOutage',
      'shouldUseTermEndDate',
      'isCancelAndReplaceSubscription',
      'enableServerNextChargeDateLogic',
      'enableServerNextChargeDateLogicPhase2',
      'getBoughtBasePlanInfo',
      'inrCitEnabled',
      'basicConfigReady'
    ]),
    editNotBasePlan() {
      if (!this.$context.is.edit) {
        return false
      }
      return this.getCurrentBasePlanInfo?.plans[0]?.category !== this.currentEditPlan?.category
    },
    isTargetServerScope() {
      if (!this.basicConfigReady) return false;
      if (this.inrCitEnabled) return false;
      //1.add flow
      if (this.$context.is.add2cart) {
        if (this.isCancelAndReplaceSubscription) return false;
        return true;
      }

      //2.edit flow add license
      if (this.$context.is.edit) {
        if (this.shouldUseTermEndDate) return false;
        if (this.isCurrentEditDownSell) return false;
        if (this.isCancelAndReplaceSubscription) return false;
        if (this.editNotBasePlan) return false;

        const oldBillingCycle = this.currentEditPlan?.billing_cycle;
        const newBillingCycle = this.getSelectedPlans[0]?.billing_cycle;
        const isSwitchBillingCycle = oldBillingCycle !== newBillingCycle;
        if (isSwitchBillingCycle) return false;

        return true;
      }

      return false;
    },
    isTargetServerScope2() {
      if (!this.basicConfigReady) return false;
      if (this.inrCitEnabled) return false;
      if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.buyTrial) {
        return false;
      }
      return true;
    },
    mx_enableServerNextChargeDateLogic() {
      if (this.enableServerNextChargeDateLogicPhase2) {
        return this.isTargetServerScope2;
      } else if (this.enableServerNextChargeDateLogic) {
        return this.isTargetServerScope;
      }
      return false;
    },
    mx_upgrade_nextChargeLabel() {
      const { totalDiscount = 0 } = this.discountWithAmountMap || {};
      // filter zp base plan (pay as you go)
      const getSelectedPlans = this.getSelectedPlans.filter(p => p.amount > 0);
      if (getSelectedPlans.every(x => x.billing_cycle === BILLING_CYCLE.MONTHLY) && !totalDiscount) return this.monthlyLabel;
      if (getSelectedPlans.every(x =>x.billing_cycle === BILLING_CYCLE.ANNUAL) && !totalDiscount) return this.annuallyLabel;
      if (getSelectedPlans.every(x =>x.billing_cycle === BILLING_CYCLE.QUARTERLY) && !totalDiscount) return this.quarterlyLabel;
      if (getSelectedPlans.every(x =>x.billing_cycle === BILLING_CYCLE.TWO_YEARS) && !totalDiscount) return this.twoYearsLabel;
      if (getSelectedPlans.every(x =>x.billing_cycle === BILLING_CYCLE.THREE_YEARS) && !totalDiscount) return this.threeYearsLabel;
      return this.$t('billing.order_summary.todays_total');
    },
    monthlyLabel() {
      if (this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade) return this.$t('billing.order_summary.total_billed_monthly_new');
      if (this.$context.is.pro2biz || this.$context.is.edit || this.mixBuyFlowContainsEditCase || this.$context.is.zs2ze || this.$context.is.add2cart) return this.$t('billing.order_summary.total_billed_monthly_new');
      return this.$t('billing.order_summary.total_billed_monthly');
    },
    annuallyLabel() {
      if (this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade) return this.$t('billing.order_summary.total_billed_annually_new');
      if (this.$context.is.pro2biz || this.$context.is.edit || this.mixBuyFlowContainsEditCase || this.$context.is.zs2ze || this.$context.is.add2cart) return this.$t('billing.order_summary.total_billed_annually_new');
      return this.$t('billing.order_summary.total_billed_annually');
    },
    quarterlyLabel() {
      if (this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade || this.$context.is.pro2biz || this.$context.is.edit || this.mixBuyFlowContainsEditCase || this.$context.is.zs2ze || this.$context.is.add2cart) return this.$t('billing.order_summary.total_billed_quarterly_new');
      return this.$t('billing.order_summary.total_billed_quarterly');
    },
    twoYearsLabel() {
      if (this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade || this.$context.is.pro2biz || this.$context.is.edit || this.mixBuyFlowContainsEditCase || this.$context.is.zs2ze || this.$context.is.add2cart) return this.$t('billing.order_summary.total_billed_two_years_new');
      return this.$t('billing.order_summary.total_billed_two_years');
    },
    threeYearsLabel() {
      if (this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade || this.$context.is.pro2biz || this.$context.is.edit || this.mixBuyFlowContainsEditCase || this.$context.is.zs2ze || this.$context.is.add2cart) return this.$t('billing.order_summary.total_billed_three_years_new');
      return this.$t('billing.order_summary.total_billed_three_years');
    },
  },
  methods: {
    //Deprecated
    mx__deprecated__nextDate(startTime, cycle, isOutputPureDate = false) {
      let time;
      // when monthly base plan,will evergreen = true, term = 100, so should choose latest time between {contract term date} and {cycle date}
      let evergreen = false;
      if (this.$context.is.edit) {
        //normal edit
        startTime = new Date(this.currentEditPlan?.cartInfo?.planStartTime || new Date());

        if (this.shouldUseTermEndDate) {
          time = moment(new Date(this.basicConfig?.termEndDate)).format(dateformat);
          //if evergreen === true
          if (this.basicConfig?.evergreen === true) {
            evergreen = true;
          }
        } else if (this.isCurrentEditDownSell) {
          //if pending down sell
          if (pageConfig?.editConfig?.planType === planTypes.CMR) {
            startTime = new Date(this.currentEditPlan?.cartInfo?.planStartTime || new Date());
          } else {
            time = moment(new Date(this.currentEditPlan?.cartInfo?.planExpireTime)).format(dateformat);
          }
        } else if (this.isCancelAndReplaceSubscription) {
          startTime = new Date();
        } else if (this.editNotBasePlan) {
          const isM2A = this.currentEditPlan?.billing_cycle === BILLING_CYCLE.MONTHLY && cycle === BILLING_CYCLE.ANNUAL;
          const isA2M = this.currentEditPlan?.billing_cycle === BILLING_CYCLE.ANNUAL && cycle === BILLING_CYCLE.MONTHLY;
          if (isM2A) {
            const baseBillingCycle = this.getCurrentBasePlanInfo?.plans[0]?.billing_cycle;
            if (baseBillingCycle === BILLING_CYCLE.ANNUAL) {
              //auto add can't get planExpireTime from basePlanInfo
              const planExpireTime = this.getCurrentBasePlanInfo?.plans[0]?.cartInfo?.planExpireTime ||
                this.boughtPlans.find((p) => p.plan_code === this.getCurrentBasePlanInfo?.plans[0]?.plan_code)?.cartInfo?.planExpireTime;
              time = moment(new Date(planExpireTime)).format(dateformat);
            } else if (baseBillingCycle === BILLING_CYCLE.MONTHLY) {
              //edit standalone
              const baseStartTime = this.getCurrentBasePlanInfo?.plans[0]?.cartInfo?.planStartTime ||
                this.boughtPlans.find((p) => p.plan_code === this.getCurrentBasePlanInfo?.plans[0]?.plan_code)?.cartInfo?.planStartTime;
              startTime = new Date(baseStartTime);
            }
          } else if (isA2M) {
            const now = moment();
            time = moment(startTime).clone().year(now.year()).month(now.month());
            if (time.isBefore(now)) {
              time.add(...span[BILLING_CYCLE.MONTHLY]);
            }
            time = time.format(dateformat);
          }
        } else if (!this.editNotBasePlan) {
          const isA2M = this.currentEditPlan.billing_cycle === BILLING_CYCLE.ANNUAL && cycle === BILLING_CYCLE.MONTHLY;
          if (isA2M) {
            const now = moment();
            time = moment(startTime).clone().year(now.year()).month(now.month());
            if (time.isBefore(now)) {
              time.add(...span[BILLING_CYCLE.MONTHLY]);
            }
            time = time.format(dateformat);
          }
        }
      } else if (this.$context.is.pro2biz) {
        startTime = new Date(this.boughtPlans[0]?.cartInfo.planStartTime || new Date());
      } else if (this.$context.is.add2cart || this.$context.is.trial2paid || this.$context.is.zs2ze || this.$context.is.upgrade) {
        // FREE TRIAL - trial2paid flow, whatever the plan is, even the plan is relative independent like Scheduler, its charge date would be still same as the base plan(Pro/Biz > Phone...) if the user had bought before.
        //this.getCurrentBasePlanInfo?.plans[0]?.cartInfo?.planStartTime may is null
        let planStartTime = this.getCurrentBasePlanInfo?.plans[0]?.cartInfo?.planStartTime
          || this.boughtPlans.find((p) => p.plan_code === this.getCurrentBasePlanInfo?.plans[0]?.plan_code)?.cartInfo?.planStartTime
          //for only buy standalone plan, then add2card
          || this.boughtPlans[0]?.cartInfo?.planStartTime
          || new Date();
        startTime = new Date(planStartTime);
        if (this.$context.is.add2cart) {
          if (this.isCancelAndReplaceSubscription) {
            startTime = new Date();
          } else {
            // 1.2024/8/1 buy pro annual
            // 2.2024/10/09 add cloud storage
            // should show 2024/11/01 not 2024/09/01
            const baseIsAnnual = this.getCurrentBasePlanInfo?.plans[0]?.billing_cycle === BILLING_CYCLE.ANNUAL;
            const newIsMonthly = cycle === BILLING_CYCLE.MONTHLY;
            const now = moment();
            if (baseIsAnnual && newIsMonthly) {
              time = moment(startTime).clone().year(now.year()).month(now.month());
              if (time.isBefore(now)) {
                time.add(...span[BILLING_CYCLE.MONTHLY]);
              }
              time = time.format(dateformat);
            }
          }
        }
      } else if (this.$context.is.biz2pro || this.$context.is.downgrade) {
        const shouldUseTermEndDate = !plansof(this.getSelectedPlans).type(planTypes.LARGE_MEETING).cycle(cycle).has();
        // if use term end date, follow edit flow
        if (shouldUseTermEndDate) {
          const meetingCancelled = this.currentEditPlan?.cartInfo?.cancelled === true;
          let endDate = (meetingCancelled ? this.currentEditPlan?.cartInfo?.originalPlanExpireTime : this.basicConfig?.termEndDate) || new Date();
          time = moment(new Date(endDate)).format(dateformat);
          if (this.basicConfig?.evergreen === true) {
            evergreen = true;
          }
          startTime = new Date(this.getBoughtBasePlanInfo?.plans[0]?.cartInfo?.planStartTime || new Date());
          // otherwise, follow add2cart flow
        } else {
          let planStartTime = this.getCurrentBasePlanInfo?.plans[0]?.cartInfo?.planStartTime;
          if (!planStartTime) {
            planStartTime = this.getBoughtBasePlanInfo?.plans[0]?.cartInfo?.planStartTime
              //for only buy standalone plan, then add2card
              || this.boughtPlans[0]?.cartInfo?.planStartTime
              || new Date();
          }
          startTime = new Date(planStartTime);
        }
      }

      if (!span[cycle]) return '';

      let expireTime = moment(startTime)
        .add(...span[cycle])
        .format(dateformat);

      if (evergreen && time && expireTime) {
        time = _.sortBy([time, expireTime], d => new Date(d))[0];
      }

      time = time ?? expireTime;
      if (isOutputPureDate) return time;
      return this.isZuoraOutage ? this.$t('billing.zuoraoutage.expire_date', [time]) : `${this.$t('billing.order_summary.next_charge_date')} ${time}`;
    },
  },
};
